import { ICompanyTableControls, IContactTableControls } from "@store/filters/filter.types";

const INITIAL_CONTACT_FILTERS = {
  hasAttendedConference: false,
  hasVerifiedEmail: false,
  jobTitles: [],
  keywords: [],
  locations: [],
  search: "",
};

const INITIAL_COMPANY_STATE: ICompanyTableControls = {
  filters: {
    companyEmployeeSizes: ["Small", "Medium", "Large", "Enterprise"],
    companyTypes: ["Non-profit", "For-profit"],
    forProfit: true,
    maxEmployees: Infinity,
    minEmployees: 0,
    nonProfit: true,
  },
  pagination: {
    page: 0,
    pageSize: 50,
  },
  selection: [],
  sort: [{ field: "numEmployees", sort: "desc" }],
};

const INITIAL_CONTACT_STATE: IContactTableControls = {
  filters: INITIAL_CONTACT_FILTERS,
  pagination: {
    page: 0,
    pageSize: 50,
  },
  selection: [],
  sort: [],
};

const INITIAL_TECHNOLOGY_COMPANY_STATE: ICompanyTableControls = {
  filters: {
    companyEmployeeSizes: ["Small", "Medium", "Large", "Enterprise"],
    companyTypes: ["Non-profit", "For-profit"],
  },
  pagination: {
    page: 0,
    pageSize: 20,
  },
  selection: [],
  sort: [],
};

const INITIAL_TECHNOLOGY_CONTACT_STATE: IContactTableControls = {
  filters: INITIAL_CONTACT_FILTERS,
  pagination: {
    page: 0,
    pageSize: 20,
  },
  selection: [],
  sort: [],
};

export const INITIAL_FILTERS_STATES_MAP = {
  company: INITIAL_COMPANY_STATE,
  contact: INITIAL_CONTACT_STATE,
  technologyCompany: INITIAL_TECHNOLOGY_COMPANY_STATE,
  technologyContact: INITIAL_TECHNOLOGY_CONTACT_STATE,
};
